import Image from 'components/Image'
import errorBackground from 'images/error-background.jpg'
import LotSection from 'components/pages/LotPage/LotSection'
import React from 'react'
import { LotScheduleQuery } from 'components/pages/LotSchedulePage/types/lotScheduleQuery'
import { HeroLinksType } from 'components/HeroSection/LinksSection'
import Calendar from 'components/pages/LotSchedulePage/Calendar'

type Props = {
  isLotGroup: boolean
  locationSchedule:
    | NonNullable<LotScheduleQuery['lot']>['locationSchedule']
    | NonNullable<LotScheduleQuery['lotGroup']>['locationSchedule']
  heroLinks: HeroLinksType
  name: string
  address?: string | null
  subscriptionLotId: number | null
}

const LotSchedulePageContent = ({
  isLotGroup,
  locationSchedule,
  heroLinks,
  address,
  name,
  subscriptionLotId
}: Props) => {
  return (
    <div className="w-full">
      <div className="absolute top-22 left-0 right-0 w-full h-96 overflow-hidden">
        <Image
          className="object-cover object-center"
          layout="fill"
          quality={75}
          src={errorBackground}
        />
        <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-96 bg-black opacity-50" />
        <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-96 flex items-center">
          <div className="mx-auto max-w-screen-md w-full lg:max-w-7xl md:px-8 px-4">
            <LotSection
              address={address}
              heroLinks={heroLinks}
              name={name}
              subscriptionLotId={subscriptionLotId}
            />
          </div>
        </div>
      </div>

      <div className="mt-96 mx-auto max-w-screen-md lg:max-w-7xl md:px-8 px-4 mb-24">
        <Calendar isLotGroup={isLotGroup} locationSchedule={locationSchedule} />
      </div>
    </div>
  )
}

export default LotSchedulePageContent
